import React, { Component } from 'react';
import { Button, Icon, Modal } from 'antd';
import styled, { keyframes } from 'styled-components';
import { Link as RouterLink } from 'react-router-dom';

class HeaderCollapse extends Component {
  state = {
    visible: false,
  };
  showModal = () => {
    this.setState({
      visible: true,
    });
  }
  hideModal = () => {
    this.setState({
      visible: false,
    });
  }

  render() {
    const { className, linksConfig, dayTime } = this.props;
    const links = linksConfig.map((link, i) => (
      <StyledLink key={i}>
        <span className="link-icon">
          <Icon type={link.icon} />
        </span>
        <span onClick={this.hideModal} className="link-text">
          <RouterLink to={link.href}>{link.text}</RouterLink>
        </span>
      </StyledLink>
    ));
    return (
      <div className={className}>
        <Button type="dashed" onClick={this.showModal} ghost={dayTime !== 'day'}>
          <Icon type="down" />
        </Button>
        <Modal
          bodyStyle={{ display: 'flex', flexDirection: 'column' }}
          style={{ top: 20 }}
          visible={this.state.visible}
          onCancel={this.hideModal}
          footer={null}
          closable={false}
        >
          {links}
        </Modal>
      </div>
    );
  }
}

const iconAnimation = keyframes`
  0% { transform: scale(1); }
  20% { transform: scale(1.1); }
  50% { transform: scale(1); } 
  100% { transform: scale(1); }
`;
const textAnimation = keyframes`
  0% { transform: scale(1); }
  20% { transform: scale(1.04); }
  50% { transform: scale(1); }
  100% { transform: scale(1); }
`;

const StyledLink = styled.div`
  display:flex;
  font-size: 2.4em;
  width:100%;
  .link-icon {
    animation: ${iconAnimation} 1.5s  infinite;
    width: 20%;
    text-align: center;
  }
  .link-text {
    animation: ${textAnimation} 1.5s .75s infinite;
    width: 80%;
    text-align: center;
  }
`;

export default HeaderCollapse;



// WEBPACK FOOTER //
// ./src/Components/HeaderCollapse/index.js